export default "__VITE_ASSET__Dd0SqV6D__"